module.exports = __webpack_public_path__ + "img/view-reports.112b3aa1.svg";